<template>
  <div>
    <div class="card" v-if="listing">
      <div class="card-body">
        <div class="row mb-4 mt-2">
          <div class="col">
            <h3>{{ $t('message.my_listings.about_your_place') }}</h3>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-sm-3">
            <label for="name">{{ $t('message.my_listings.name') }}</label>
          </div>
          <div class="col-sm-9">
            <input id="name"
                   name="name"
                   type="text"
                   class="form-control"
                   :class="{'form-alert': errors.has('name')}"
                   v-validate="'required'"
                   v-model="listing.place_name"
                   @input="updateData('place_name', $event)">
            <div class="mt-1 text-remark -status-alert" v-if="errors.has('name')">
              {{ $t('message.required_field') }}
            </div>
          </div>
        </div>
        <!--/.form-group-->
        <div class="row mb-3">
          <div class="col-sm-3">
            <label for="place_size_id">{{ $t('message.my_listings.type') }}</label>
          </div>
          <div class="col-sm-9">
            <select
              id="place_size_id"
              class="form-control"
              v-model="listing.place_size_id"
              @change="updateData('place_size_id', $event)">
              <option v-for="(placeSize, index) in sortedPlaceSizes"
                      :value="sortedPlaceSizes[index].id"
                      :key="index">
                {{ placeSize | multiLangName }}
              </option>
            </select>
          </div>
        </div>
        <!--/.form-group-->
        <div class="row mb-3">
          <div class="col-sm-3" for="">
            <label for="city">{{ $t('message.my_listings.city') }}</label>
          </div>
          <div class="col-sm-9">
            <select
              id="city"
              name="city"
              class="form-control"
              :class="{'form-alert': errors.has('city')}"
              v-validate="'required|regex:[^0]+'"
              v-model="listing.province_id"
              @change="changeCity(listing.province_id)">
              <option v-for="(city, index) in sortedCities"
                      :value="sortedCities[index].id"
                      :key="index"
                      v-if="sortedCities[index].id !== 0">
                {{ city | multiLangName }}
              </option>
            </select>
            <div class="mt-1 text-remark -status-alert" v-if="errors.has('city')">
              {{ $t('message.required_field') }}
            </div>
          </div>
        </div>
        <!--/.form-group-->

        <div class="row mb-3">
          <div class="col-sm-3">
            <label for="remark">{{ $t('message.my_listings.remark') }}</label>
          </div>
          <div class="col-sm-9">
            <textarea
              id="remark"
              :placeholder="$t('message.my_listings.remark_placeholder')"
              rows="2"
              class="form-control"
              v-model="listing.remark"
              @input="updateData('remark', $event)"></textarea>
          </div>
        </div>
        <!--/.form-group-->
        <div class="row my-4">
          <div class="col">
            <h3>{{ $t('message.my_listings.address_information') }}</h3>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-sm-3">
            <label for="address">{{ $t('message.my_listings.address') }}</label>
          </div>
          <div class="col-sm-9">
          <textarea
            id="address"
            name="address"
            rows="2"
            :placeholder="$t('message.my_listings.location_placeholder')"
            class="form-control"
            :class="{'form-alert': errors.has('address')}"
            v-validate="'required'"
            v-model="listing.address"
            @input="updateData('address', $event)"></textarea>
            <div class="mt-1 text-remark -status-alert" v-if="errors.has('address')">
              {{ $t('message.required_field') }}
            </div>
          </div>
        </div>
        <!--/.form-group-->

        <div class="row mb-3">
          <div class="col-sm-3">
            <label for="place_size_id">{{ $t('message.my_listings.province') }}</label>
          </div>
          <div class="col-sm-9">
            <select v-model="listing.address_province_id"
                    @change="changeAddressProvince(listing.address_province_id)"
                    class="form-control"
                    :class="{'form-alert': errors.has('addressProvince')}"
                    v-validate="'required'"
                    id="addressProvince"
                    name="addressProvince">
              <option :value="null">{{ $t('message.booking.contact_step.set_province') }}</option>
              <option :value="addressProvince.id"
                      v-for="(addressProvince, index) in sortedProvinces"
                      :key="index">
                {{ addressProvince | multiLangName }}
              </option>
            </select>
            <div class="mt-1 text-remark -status-alert" v-if="errors.has('addressProvince')">
              {{ $t('message.required_field') }}
            </div>
          </div>
        </div>
        <!--/.form-group-->

        <div class="row mb-3">
          <div class="col-sm-3">
            <label for="place_size_id">{{ $t('message.my_listings.district') }}</label>
          </div>
          <div class="col-sm-9">
            <select v-model="listing.district_id"
                    @change="changeDistrict(listing.district_id)"
                    class="form-control"
                    :class="{'form-alert': errors.has('district')}"
                    v-validate="'required'"
                    id="district"
                    name="district">
              <option :value="null">{{ $t('message.booking.contact_step.set_district') }}</option>
              <option :value="district.id"
                      v-for="(district, index) in sortedDistricts"
                      :key="index">
                {{ district | multiLangName }}
              </option>
            </select>
            <div class="mt-1 text-remark -status-alert" v-if="errors.has('district')">
              {{ $t('message.required_field') }}
            </div>
          </div>
        </div>
        <!--/.form-group-->

        <div class="row mb-3">
          <div class="col-sm-3">
            <label for="place_size_id">{{ $t('message.my_listings.sub_district') }}</label>
          </div>
          <div class="col-sm-9">
            <select v-model="listing.sub_district_id"
                    class="form-control"
                    id="sub-district">
              <option :value="null">{{ $t('message.booking.contact_step.set_sub_district') }}</option>
              <option :value="subDistrcict.id"
                      v-for="(subDistrcict, index) in sortedSubDistricts"
                      :key="index">
                {{ subDistrcict | multiLangName }}
              </option>
            </select>
          </div>
        </div>
        <!--/.form-group-->
        
        <div class="row mt-4">
          <div class="col">
            <pet-selection-label/>
            <div class="d-flex justify-content-center align-items-center pt-2">
              <div class="flex-fill">
                <label><i class="fas fa-paw"></i> {{ $t('message.booking.contact_step.pet_remark') }}</label>
              </div>
              <div>
                <toggle-button v-model="switchHasPet" 
                              :sync="true"
                              color="#8BC34A"
                              @change="onChangeHasPet"/>
              </div>
            </div>
            <div class="py-2" v-if="isClearing">
              <loader-small></loader-small>
            </div>
            <div v-else>
              <div class="d-flex justify-content-start align-items-center flex-wrap" v-if="selectedPetTypes">
                <div v-for="petType in selectedPetTypes">
                  <div class="d-flex justify-content-start align-items-center border border-chip-gray rounded-pill px-2 py-1 mr-2 mb-2">
                    <div class="pr-2" v-if="petType.image_url">
                      <img :src="petType.image_url" width="24">
                    </div>
                    <div>{{ petType | multiLangName }} <span v-if="petType.remark">:{{ petType.remark }}</span></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col">
            <label>{{ $t('message.my_listings.location') }}</label>
            <span class="d-inline-flex" v-if="displayAlertNoLocation">
              <i class="fas fa-exclamation-circle text-danger"></i>
            </span>
            <div class="text-remark pb-3">{{ $t('message.my_listings.place_location_hint') }}</div>
            <div class="d-flex justify-content-start align-items-center mb-3">
              <div class="flex-fill">
                <gmap-autocomplete
                  :placeholder="$t('message.my_listings.place_location_search')"
                  class="form-control"
                  @place_changed="getAddressData"/>
              </div>
              <div class="pl-2">
                <button class="btn btn-outline-secondary" @click="getGeoLocation">
                  <i class="fas fa-map-marker-alt"></i>
                </button>
              </div>
            </div>

            <div class="embed-responsive embed-responsive-16by9 rounded" v-show="state.center">
              <div class="embed-responsive-item">
                <gmap-map ref="gmap"
                          :center="state.center"
                          :zoom="14"
                          :options="{clickableIcons: false}"
                          @click="changeLocation"
                          style="width: 100%; height: 100%;">
                  <gmap-marker
                    v-for="(marker, index) in state.markers"
                    :key="index"
                    :position="marker.position"
                    :clickable="true"/>
                </gmap-map>
              </div>
            </div>
          </div>
        </div>
        <!--/.form-group-->
        <div class="row pt-4">
          <div class="col-sm-12">
            <label>{{ $t('message.my_listings.checklist') }}</label>
            <div class="text-remark mb-2">{{ $t('message.my_listings.checklist_remark') }}</div>
          </div>
        </div>
        <div class="d-flex mb-2">
          <div class="flex-fill pl-3">
            <input id="checklist"
                   type="text"
                   class="form-control"
                   :placeholder="$t('message.my_listings.add_checklist')"
                   v-model="checklistData"
                   @keyup.enter="addChecklist">
          </div>
          <div class="pl-2 pr-3">
            <button type="button" class="btn btn-success " @click="addChecklist">
              <i class="far fa-plus"></i> {{ $t('message.button.add') }}
            </button>
          </div>
        </div>
        <div class="row" v-if="arrChecklist">
          <div class="col-sm-12">
            <draggable v-model="arrChecklist">
              <div class="card"
                    v-for="(checklist, index) in arrChecklist"
                    :key="index">
                <div class="card-body py-2">
                  <div class="row">
                    <div class="col-10 p-0">
                      <i class="fas fa-check -status-accepted"></i>&nbsp;
                      {{ checklist }}
                    </div>
                    <div class="col-2 p-0 text-right">
                      <i class="fas fa-times pointer-item" @click="removeChecklist(index)"></i>
                    </div>
                  </div>
                </div>
              </div>
            </draggable>
          </div>
        </div>
        <!--/.form-group-->
        <div class="row mt-4">
          <div class="col">
            <button class="btn btn-info btn-block"
                    :disabled="isLoading"
                    @click="saveData">
              {{ (isLoading) ? $t('message.button.loading') : $t('message.button.save') }}
            </button>
            <div class="text-center mt-3">
              <router-link to="/user/listings" class="text-primary-link">
                <i class="far fa-chevron-left"></i>
                {{ $t('message.booking.new_booking.back') }}
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="text-center" v-else>
      <div class="p-4 text-secondary">
        <div class="pb-2"><i class="fal fa-home fa-2x"></i></div>
        {{ $t('message.my_listings.no_data') }}
      </div>
    </div>
    <snackbar ref="snackbar"
              baseSize="100px"
              :colors="{open: '#333', info: '#3DBD7D', error: '#FA7377', warn: '#FF6600'}"
              :holdTime="2500"
              :position="'bottom-center'"/>
     <pet-type-modal ref="petTypeModal" @onUpdateResult="updateUserPlacePetTypes" />
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import draggable from 'vuedraggable'
  import PetSelectionLabel from '../../booking/components/PetSelectionLabel'
  import PetTypeModal from '../../booking/components/PetTypeModal'
  import axios from 'axios'

  export default {
    components: {
      draggable,
      PetSelectionLabel,
      PetTypeModal
    },
    data () {
      return {
        userPlaceId: null,
        action: 'add',
        formTitle: 'message.my_listings.add_new_listing',
        sortBy: (this.$i18n.locale === 'th') ? 'name_th' : 'name_en',
        arrChecklist: [],
        checklistData: null,
        displayAlertNoLocation: false,
        isDoneLoading: false,
        switchHasPet: false,
        selectedPetTypes: null,
        isClearing: false
      }
    },
    computed: {
      ...mapGetters({
        globalState: 'globalVal/getState',
        listing: 'listing/getListingDetail',
        state: 'listing/getState',
        user: 'auth/getUser'
      }),
      ...mapState('addressProvince', ['addressProvinces', 'districts', 'subDistricts']),
      isLoading () {
        return this.state.isRequesting
      },
      sortedCities () {
        return this._.orderBy(this.globalState.cities, [this.sortBy], ['asc'])
      },
      sortedPlaceSizes () {
        return this._.orderBy(this.globalState.placeSizes, ['id'], ['asc'])
      },
      sortedProvinces () {
        return this._.orderBy(this.addressProvinces, [this.sortBy], ['asc'])
      },
      sortedDistricts () {
        return this._.orderBy(this.districts, [this.sortBy], ['asc'])
      },
      sortedSubDistricts () {
        return this._.orderBy(this.subDistricts, [this.sortBy], ['asc'])
      }
    },
    watch: {
      listing () {
        if (this.listing && this.listing.checklist) {
          this.arrChecklist = this.listing.checklist
        }
      },
      'listing.has_pet': function (newVal, oldVal) {
        if (newVal === 0) {
          this.listing.pet_remark = null
        }
      }
    },
    methods: {
      async onChangeHasPet (event) {
        if (event.value) {
          this.$refs.petTypeModal.showModal(true)
        } else {
          // clear data
          const userPlaceId = this.listing.id
          if (userPlaceId) {
            this.isClearing = true
            const url = `/users-places/${userPlaceId}/pet-type`
            await axios.post(url, { pet_type_ids: [] })
            this.isClearing = false
          }
          this.selectedPetTypes = null
          this.listing.has_pet = 0
        }
      },
      updateUserPlacePetTypes (data) {
        // update switch
        this.switchHasPet = data.hasPet
        // update user place data
        const hasPet = (data.hasPet) ? 1 : 0
        this.listing.has_pet = hasPet
        this.selectedPetTypes = null
        if (data.selectedPetTypes) {
          this.selectedPetTypes = data.selectedPetTypes
        }
      },
      getGeoLocation () {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(position => {
            this.displayAlertNoLocation = false
            const lat = position.coords.latitude
            const lng = position.coords.longitude
            this.setMap(lat, lng, true)
          }, error => {
            this.$swal({ text: error.message, type: 'error' })
          }, { timeout: 10000 })
        } else {
          this.$swal({ text: 'This browser blocked or did not support location service', type: 'error' })
        }
      },
      changeAddressProvince (id) {
        this.fetchDistricts(id)
        this.listing.district_id = null
        this.listing.sub_district_id = null
      },
      changeDistrict (id) {
        this.fetchSubDistricts(id)
        this.listing.sub_district_id = null
      },
      addChecklist () {
        if (this.checklistData) {
          this.arrChecklist.push(this.checklistData)
          this.checklistData = ''
        }
      },
      removeChecklist (index) {
        this.arrChecklist.splice(index, 1)
      },
      // Map methods
      setMap (lat, lng, canSetLocation) {
        // Get lat,lng of Bangkok as default
        if (!lat && !lng) {
          lat = this.globalState.citiesLocations[1].lat
          lng = this.globalState.citiesLocations[1].lng
        }

        if (canSetLocation) {
          this.$store.commit('listing/UPDATE_FORM_DATA', { key: 'latitude', value: lat })
          this.$store.commit('listing/UPDATE_FORM_DATA', { key: 'longitude', value: lng })
        }
        lat = parseFloat(lat)
        lng = parseFloat(lng)

        // Set map & markers
        const center = { lat: lat, lng: lng }
        const markers = []
        markers[0] = { position: { lat: lat, lng: lng } }
        this.$store.commit('listing/SET_MAP_CENTER', center)
        this.$store.commit('listing/SET_MAP_MARKERS', markers)
      },
      getAddressData (addressData) {
        this.displayAlertNoLocation = false
        const lat = addressData.geometry.location.lat()
        const lng = addressData.geometry.location.lng()
        this.setMap(lat, lng, true)
      },
      changeLocation (event) {
        this.displayAlertNoLocation = false
        const lat = event.latLng.lat()
        const lng = event.latLng.lng()
        this.setMap(lat, lng, true)
      },
      changeCity (id) {
        const lat = this.globalState.citiesLocations[id].lat
        const lng = this.globalState.citiesLocations[id].lng
        this.setMap(lat, lng, false)
        this.$store.commit('listing/UPDATE_FORM_DATA', { key: 'province_id', value: id })
      },
      // get user place by id
      async fetchListingDetail (id) {
        this.action = 'update'
        this.formTitle = 'message.my_listings.edit_listing'
        await this.$store.dispatch('listing/LOAD_LISTING_DETAIL', id)
        this.isDoneLoading = true
        if (this.listing) {
          // Set province, district, sub district
          if (this.listing.address_province_id) {
            await this.fetchDistricts(this.listing.address_province_id)
          }
          if (this.listing.district_id) {
            await this.fetchSubDistricts(this.listing.district_id)
          }

          // Set location
          let lat = this.listing.latitude
          let lng = this.listing.longitude
          const canSetLocation = (this.listing.latitude !== null && this.listing.latitude !== 0.0)
          if (!canSetLocation) {
            const provinceId = Number(this.listing.province_id)
            lat = this.globalState.citiesLocations[provinceId].lat
            lng = this.globalState.citiesLocations[provinceId].lng
          }
          this.setMap(lat, lng, canSetLocation)

          // Check pet types
          if (this.listing.user_place_pet_types.length) {
            this.switchHasPet = true
            this.selectedPetTypes = []
            this.listing.user_place_pet_types.forEach(item => {
              if (item.pet_type.is_other) {
                item.pet_type.remark = item.remark
              }
              this.selectedPetTypes.push(item.pet_type)
            })
          }
        }
      },
      setEmptyForm () {
        this.action = 'add'
        this.formTitle = 'message.my_listings.add_new_listing'
        this.$store.commit('listing/SET_EMPTY_FORM')
      },
      updateData (attribute, e) {
        const data = { key: attribute, value: e.target.value }
        this.$store.commit('listing/UPDATE_FORM_DATA', data)
      },
      saveData () {
        this.$validator.validate().then(async (valid) => {
          if (valid && this.listing.latitude && this.listing.longitude) {
            const checklist = this.arrChecklist.length > 0 ? this.arrChecklist : null

            // Prepare submit data
            const submitData = {
              user_id: this.user.id,
              place_name: this.listing.place_name,
              place_size_id: this.listing.place_size_id,
              province_id: this.listing.province_id,
              address: this.listing.address,
              latitude: this.listing.latitude,
              longitude: this.listing.longitude,
              remark: this.listing.remark,
              has_pet: this.listing.has_pet,
              pet_remark: this.listing.pet_remark,
              checklist: checklist,
              address_province_id: this.listing.address_province_id,
              district_id: this.listing.district_id,
              sub_district_id: this.listing.sub_district_id
            }

            if (this.action === 'update') {
              submitData.id = this.listing.id
            }

            // Save user place
            await this.$store.dispatch('listing/SAVE_USER_PLACE', submitData)
            this.$router.push('/user/listings')
          } else if (valid && !this.listing.latitude) {
            this.displayAlertNoLocation = true
            const alertMessage = this.$i18n.t('message.my_listings.error_no_location')
            this.$refs.snackbar.error(alertMessage)
          }
        })
      },
      // Modal methods
      showListingFormModal (status) {
        const params = {
          type: 'form',
          status: status
        }
        this.$store.commit('listing/SET_MODAL_DISPLAY', params)
        setTimeout(() => {
          this.resizeMap()
        }, 500)
      },
      resizeMap () {
        this.$refs.gmap.resizePreserveCenter()
      },
      fetchAddressProvinces () {
        this.$store.dispatch('addressProvince/LOAD_ADDRESS_PROVINCES')
      },
      fetchDistricts (provinceId) {
        if (provinceId) {
          const queryData = {
            province_id: provinceId
          }
          this.$store.dispatch('addressProvince/LOAD_DISTRICTS', queryData)
        }
      },
      fetchSubDistricts (districtId) {
        if (districtId) {
          const queryData = {
            district_id: districtId
          }
          this.$store.dispatch('addressProvince/LOAD_SUB_DISTRICTS', queryData)
        }
      }
    },
    mounted () {
      this.setMap(null, null, false)
      if (this.$route.params.id) {
        this.userPlaceId = this.$route.params.id
        this.isDoneLoading = false
        this.fetchListingDetail(this.userPlaceId)
      } else {
        this.isDoneLoading = true
        this.$store.commit('listing/CREATE_NEW_USER_PLACE')
      }
      this.fetchAddressProvinces()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/user/listing/ListingForm.vue